import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import { ConfigProvider } from 'antd';
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import { Provider } from 'react-redux';
import store from './store/store';

if (window.location.host.includes('localhost')) {
  axios.defaults.baseURL = 'http://localhost:4001/';
} else if (process.env.REACT_APP_T2_API_URL) {
  axios.defaults.baseURL = process.env.REACT_APP_T2_API_URL;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        {' '}
        {/* Wrap App with BrowserRouter */}
        <ConfigProvider
          theme={{
            components: {
              Button: {
                colorPrimary: '#4931C0',
              },
            },
          }}
        >
          <App />
        </ConfigProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
